import { render, staticRenderFns } from "./GraphDetail06Template.vue?vue&type=template&id=66e70dde&scoped=true"
import script from "./GraphDetail06Template.vue?vue&type=script&lang=js"
export * from "./GraphDetail06Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e70dde",
  null
  
)

export default component.exports